import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewsDetailsModalComponent } from '../../modals/news-details/news-details.modal.component';

/**
 *
 * */
@Component({
  selector: 'campfire-news-card',
  templateUrl: './news-card.component.html',
  styleUrls: ['./news-card.component.scss']
})
export class NewsCardComponent {
  @Input() news;

  constructor(private modalService: NgbModal) {

  }

  get title(): string {
    return this.news.fields.Title;
  }

  get description(): string {
    return this.news.fields.Blurb;
  }

  get urlDescription(): string {
    return this.news.fields.URL.Description;
  }

  get url(): string | null {
    if (!this.news.fields.URL) {
      return null;
    }

    return this.news.fields.URL.Url;
  }

  get imageUrl(): string {
    if (this.news.fields.Image && this.news.fields.Image.Url) {
      return this.news.fields.Image.Url;
    }
    return null;
  }

  get category(): string {
    return this.news.fields.Division;
  }

  get categoryClass(): string {
    if (this.category) {
      return `${this.category.toLowerCase()}-category`;
    }

    return null;
  }

  get subcategory(): string {
    return this.news.fields.Subcategory;
  }

  get dateCreated(): Date {
    return new Date(this.news.createdDateTime);
  }

  onNewsCardClicked($event: Event): void {
    if (!this.url && this.news.fields.LongFormDescription) {
      $event.preventDefault();

      const modalRef = this.modalService.open(NewsDetailsModalComponent, {
        centered: true,
        backdropClass: 'white-backdrop',
        windowClass: 'news-details-modal'
      });

      modalRef.componentInstance.news = this.news;
    } 
  }
}
